export const isNonNull = <T>(item: T): item is NonNullable<typeof item> => {
  return item != null;
};
